export const NEWS_EVENT_SET_SUBSCRIPTION = "NEWS_EVENT_SET_SUBSCRIPTION";
export const NEWS_EVENT_SET_LISTING = "NEWS_EVENT_SET_LISTING";
export const NEWS_EVENT_SET_THEMES = "NEWS_EVENT_SET_THEMES";
export const NEWS_EVENT_SET_TRIGGERS = "NEWS_EVENT_SET_TRIGGERS";
export const NEWS_EVENT_SET_LANGUAGE = "NEWS_EVENT_SET_LANGUAGE";
export const NEWS_EVENT_SET_ACTIVE = "NEWS_EVENT_SET_ACTIVE";
export const NEWS_EVENT_UPDATE_REQUEST = "NEWS_EVENT_UPDATE_REQUEST";
export const NEWS_EVENT_CREATE_REQUEST = "NEWS_EVENT_CREATE_REQUEST";
